<template>
    <!-- THIS ONE SHOULD BE POLICY -->
    <TopicGroup>
        <privacy-policy/>
        <security-policy/>
        <template v-slot:animations>
            <privacy-policy-animation :delay="0" :interval="10000"/>
            <security-policy-animation :delay="0" :interval="10000"/>
        </template>
    </TopicGroup>
</template>

<script>
import TopicGroup from '../TopicGroup'
import { policy } from '@/assets/svg-components'
import { policyAnimations } from '../TopicAnimations'

export default {
    components: {
        TopicGroup,
        ...policy,
        ...policyAnimations
    }
}
</script>
